import { useNavigate } from '@tanstack/react-router';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

export const Upgrade = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col justify-center px-1 py-6">
      <div className="surface-card p-6 sm:p-9">
        <div className="text-center mb-8">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-midnight text-brand-volt shadow-lg">
            <CheckCircle2 className="h-7 w-7" />
          </div>
          <p className="eyebrow mt-5">A better way to train</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-brand-midnight">
            Your race plan starts here
          </h2>
          <p className="text-gray-600 text-sm mb-8">
            Answer a few questions about your race, experience, and schedule.
            Get a personalized plan built around your race, your schedule, and
            your training history.
          </p>
          <button
            onClick={() => navigate({ to: '/checkout' })}
            className="w-full bg-brand-volt text-brand-midnight font-semibold px-6 py-3.5 rounded-xl hover:bg-brand-volt/90 transition-colors min-h-[48px]"
          >
            Unlock my race plan <ArrowRight className="ml-1 inline h-4 w-4" />
          </button>
          <button
            onClick={() => navigate({ to: '/plan/workout/new' })}
            className="w-full bg-transparent text-brand-midnight font-semibold px-6 py-3.5 rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors min-h-[48px] dark:text-white dark:border-gray-700 dark:hover:bg-gray-900"
          >
            Or generate a single workout
          </button>
        </div>

        <div className="space-y-4">
          <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
            <div className="w-8 h-8 bg-brand-blueSoft rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-brand-cobalt text-sm font-bold">1</span>
            </div>
            <div>
              <h3 className="font-semibold text-sm text-gray-900">
                Tell us about your race
              </h3>
              <p className="text-gray-600 text-xs mt-0.5">
                Race date, distance, goal time, and your PRs
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
            <div className="w-8 h-8 bg-brand-blueSoft rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-brand-cobalt text-sm font-bold">2</span>
            </div>
            <div>
              <h3 className="font-semibold text-sm text-gray-900">
                Your plan is built
              </h3>
              <p className="text-gray-600 text-xs mt-0.5">
                Periodized plan using all of human training knowledge
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
            <div className="w-8 h-8 bg-brand-blueSoft rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-brand-cobalt text-sm font-bold">3</span>
            </div>
            <div>
              <h3 className="font-semibold text-sm text-gray-900">
                Start training
              </h3>
              <p className="text-gray-600 text-xs mt-0.5">
                Daily workouts with paces, distances, and intentions
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
